export default __webpack_public_path__ + "42b73d043b3e2b277529ac2ef0d6ae56.svg";